import { Delta } from "json-difference";

export const logRemovedFields = (removedFields: Delta["removed"]) => {
  if (removedFields.length > 5) {
    console.log(
      "\x1B[1mRemoved fields:\x1B[m",
      removedFields.map(([path, value]) => ({
        path,
        value,
      })),
    );
  } else {
    removedFields.forEach(([path, value]) => {
      console.log(`\x1B[1mRemoved field ${path} with value:\x1B[m`, value);
    });
  }
};
